import React, { createElement } from 'react';
import { RichText as PrismicRichText } from 'prismic-reactjs';
import { Elements } from 'prismic-richtext';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { get } from 'dpl/shared/utils/object';

import { StructuredTextPropTypes } from '../utils/customPropTypes';
import { getArticlePath } from '../utils';

export const ELEMENT_TYPE_TO_TAG = {
  [Elements.heading1]: 'h1',
  [Elements.heading2]: 'h2',
  [Elements.heading3]: 'h3',
  [Elements.heading4]: 'h4',
  [Elements.heading5]: 'h5',
  [Elements.heading6]: 'h6',
  [Elements.hyperlink]: 'a'
};

const ANCHOR_RE = /https?:\/\/(#.*)/;

const HEADING_TYPES = [
  Elements.heading1,
  Elements.heading2,
  Elements.heading3,
  Elements.heading4,
  Elements.heading5,
  Elements.heading6
];

export function getAnchorId(text) {
  return text
    .replace(/[\W_]+/g, ' ')
    .trim()
    .replace(/[\W_]+/g, '-')
    .toLowerCase();
}

// custom html serializer that to support same-page linking via anchors:
//   - adds an `id` to all headings
//   - strips the https:// from rich text links
export function htmlSerializer(type, element, content, children, key) {
  const Tag = ELEMENT_TYPE_TO_TAG[type];
  const props = {
    ...(element.label && { className: element.label }),
    key
  };

  if (HEADING_TYPES.includes(type)) {
    return createElement(
      Tag,
      {
        ...props,
        id: getAnchorId(element.text)
      },
      children
    );
  }

  if (type === Elements.hyperlink) {
    // HACK: Prismic doesn't allow for anchors in the same page;
    // it always prepends the link with 'https://' -- so strip it out!
    const url = get(element, 'data.url', '');
    const matches = url.match(ANCHOR_RE);

    if (matches && matches.length > 0) {
      const href = matches[1];
      return createElement(Tag, { ...props, href }, children);
    }
  }

  // return falsy for default behavior
  return null;
}

export default function RichText({ content }) {
  return (
    <div className="PrismicRichText">
      <PrismicRichText
        render={content}
        linkResolver={getArticlePath}
        htmlSerializer={htmlSerializer}
      />
    </div>
  );
}

RichText.propTypes = {
  content: StructuredTextPropTypes.isRequired
};

// carry over Prismic's RichText utilities like asText
hoistNonReactStatics(RichText, PrismicRichText);
